import type { CheckoutBusService } from '@/scopes/checkout/domain/types'
import { produce } from 'immer'

interface BusServicePayload {
  participantId: string
  value: string | null
  direction: string
}

export function updateBusService(payload: BusServicePayload) {
  return produce((service: CheckoutBusService) => {
    if (payload.direction === 'outbound') {
      service.participants[payload.participantId].selectedValueOutbound = payload.value
    }
    if (payload.direction === 'inbound') {
      service.participants[payload.participantId].selectedValueInbound = payload.value
    }
  })
}
